import { Text } from "components";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import * as CUSTOM from "../../utils/helper/custom";

const Breadcrumb = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const allCategories = useMemo(() => props.allCategories || [], [props.allCategories]);
  const [breadcrumbData, setBreadcrumbData] = useState({});
  const onCategoryClick = props.onCategoryClick || (() => {});

  useEffect(() => {
      if (allCategories.length > 0) {
      const pathParts = location.pathname
        .replace(/^\/productlist\//, "")
        .split("/")
        .filter(Boolean);

      let mainSlug = "";
      let subSlug = "";
      let subSubSlug = "";
      let categoryId = "";

      if (pathParts.length === 4) {
        [mainSlug, subSlug, subSubSlug, categoryId] = pathParts;
      } else if (pathParts.length === 3) {
        [mainSlug, subSlug, categoryId] = pathParts;
      } else if (pathParts.length === 2) {
        [mainSlug, categoryId] = pathParts;
      } else if (pathParts.length === 1) {
        [mainSlug] = pathParts;
      }

      const breadcrumb = {
        mainSlug: "",
        maincategoryname: "",
        subSlug: "",
        subcatname: "",
        subSubSlug: "",
        subsubslugname: "",
        subcatid: categoryId,
        mainCategoryId: 0,
      };

      if (mainSlug) {
        const mainCat = CUSTOM.findCategoryBySlug(mainSlug, allCategories);
        if (mainCat) {
          breadcrumb.mainSlug = mainCat.slug;
          breadcrumb.maincategoryname = mainCat.name;
          breadcrumb.mainCategoryId = mainCat.mainCategoryId;
        }
      }

      if (subSlug) {
        const subCat = CUSTOM.findCategoryBySlug(subSlug, allCategories);
        if (subCat) {
          breadcrumb.subSlug = subCat.slug;
          breadcrumb.subcatname = subCat.name;

          if (!breadcrumb.maincategoryname && subCat.mainCategoryName) {
            breadcrumb.maincategoryname = subCat.mainCategoryName;
            breadcrumb.mainSlug = subCat.mainSlug;
          }
        }
      }

      if (subSubSlug) {
        const subSubCat = CUSTOM.findCategoryBySlug(subSubSlug, allCategories);
        if (subSubCat) {
          breadcrumb.subSubSlug = subSubCat.slug;
          breadcrumb.subsubslugname = subSubCat.name;
          if (!breadcrumb.maincategoryname && subSubCat.mainCategoryName) {
            breadcrumb.maincategoryname = subSubCat.mainCategoryName;
            breadcrumb.mainSlug = subSubCat.mainSlug;
          }
          if (!breadcrumb.subcatname && subSubCat.subCategoryName) {
            breadcrumb.subcatname = subSubCat.subCategoryName;
            breadcrumb.subSlug = subSubCat.subSlug;
          }
        }
      }

      setBreadcrumbData(breadcrumb);
    }
  }, [props.data, location.pathname, allCategories]);

  const handleNavigate = (level) => {
    const { mainSlug, subSlug, subSubSlug, subcatid, mainCategoryId } = breadcrumbData;
    let selectedLevel = null;if (level === 1 && mainSlug && mainCategoryId) {
      navigate(`/productlist/${mainSlug}/${mainCategoryId}`);
    } else if (level === 2 && mainSlug && subSlug && subcatid) {
      navigate(`/productlist/${mainSlug}/${subSlug}/${subcatid}`);
    } else if (level === 3 && mainSlug && subSlug && subSubSlug && subcatid) {
      navigate(`/productlist/${mainSlug}/${subSlug}/${subSubSlug}/${subcatid}`);
    }
    if (selectedLevel === 2) {
      onCategoryClick(selectedLevel);
    }
  };

  const pathParts = location.pathname.split("/").filter(Boolean);
  const isMainActive = pathParts.length === 2 || pathParts.length === 3;
  const isSubActive = pathParts.length === 4;
  const isSubSubActive = pathParts.length >= 5;

  return (
    <>
      <div className="flex flex-row font-nunitoregular gap-1 items-start justify-start mt-[30px] md:px-5 w-full flex-wrap">
        <Text
          className="text-gray-700 text-sm w-auto cursor-pointer hover:text-gray-900 transition-colors"
          size="txtnunitoRegular14"
          onClick={(e) => {
            navigate(`/`);
          }}
        >
          <span
            className="
              text-[14px]
              leading-[20px]
              font-[Inter]
              font-normal
              text-center
              text-[var(--Blacks-300,#6D737E)]
            "
          >
            {t("home")}
          </span>
        </Text>
        {props?.type === "allProduct" ? (
          <>
            <Text
              className="text-gray-700 text-sm w-auto mx-1" 
              size="txtnunitoRegular14"
            >
              /
            </Text>
            <Text
              className="text-gray-700 text-sm w-auto cursor-pointer hover:text-gray-900 transition-colors"
              size="txtnunitoRegular14"
              onClick={(e) => {
                navigate(`/`);
              }}
            >
              <span
            className="
              text-[14px]
              leading-[20px]
              font-[Inter]
              font-normal
              text-center
              text-[var(--Blacks-300,#6D737E)]
            "
          >{t("allCakes")}</span>
            </Text>
          </>
        ) : (
          <>
            {breadcrumbData?.maincategoryname && (
              <>
                <Text
                  className="text-gray-700 text-sm w-auto mx-1"
                  size="txtnunitoRegular14"
                >
                  /
                </Text>
                <Text
                  className={`text-gray-700 text-sm w-auto cursor-pointer hover:text-gray-900 transition-colors ${
                    isMainActive ? "underline font-semibold text-gray-900" : ""
                  }`}
                  size="txtnunitoRegular14"
                  onClick={() => handleNavigate(1)}
                >
                  <span
                    className="
                      text-[14px]
                      leading-[20px]
                      font-[Inter]
                      font-normal
                      text-center
                      text-[var(--Blacks-300,#6D737E)]
                    "
                  >
                    {breadcrumbData.maincategoryname}
                  </span>
                </Text>
              </>
          )}
            {breadcrumbData?.subcatname && (isSubActive || isSubSubActive) && (
              <>
                <Text
                  className="text-gray-700 text-sm w-auto mx-1"
                  size="txtnunitoRegular14"
                >
                  /

                </Text>
                <Text
                  className={`text-gray-700 text-sm w-auto cursor-pointer hover:text-gray-900 transition-colors ${
                    isSubActive ? "underline font-semibold text-gray-900" : ""
                  }`}
                  size="txtnunitoRegular14"
                  onClick={() => handleNavigate(2)}
                >
                  <span
                    className="
                      text-[14px]
                      leading-[20px]
                      font-[Inter]
                      font-normal
                      text-center
                      text-[var(--Blacks-300,#6D737E)]
                    "
                  >
                    {breadcrumbData.subcatname}
                  </span>
                </Text>
              </>
            )}

            {breadcrumbData?.subsubslugname && isSubSubActive && (
              <>
                <Text className="text-gray-700 text-sm w-auto mx-1">/</Text>
                <Text
                  className="text-gray-700 text-sm w-auto"
                  size="txtnunitoRegular14"
                  onClick={() => handleNavigate(3)}
                >
                  {breadcrumbData.subsubslugname}
                </Text>
              </>
            )}

            {breadcrumbData?.blogname && (
              <>
                <Text
                  className="text-gray-700 text-sm w-auto mx-1"
                  size="txtnunitoRegular14"
                >
                  /
                </Text>
                <Text 
                  className="text-gray-700 text-sm w-auto"
                  size="txtnunitoRegular14"
                >
                  {breadcrumbData.blogname}
                </Text>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Breadcrumb;
